export function displayLabel(containerClassName, width){
  if (width <= 0) return;

  const container = document.querySelector(containerClassName);
  if (!container) return;

  const adLabel = container.querySelector('.ads-label');
  adLabel && adLabel.remove();

  const label = document.createElement("div");
  label.innerHTML = "AD";
  label.classList.add('ads-label');
  container.appendChild(label);
}